import { useEffect } from "react"

/**
 * Hook that alerts clicks outside of the passed refs.
 *
 * @param {Array} refs - Array of refs to elements that should not trigger the handler when clicked.
 * @param {Function} handler - Function to call when a click outside the refs is detected.
 */
function useClickOutsideHandler(refs, handler) {
    useEffect(() => {
        const listener = event => {
            if (refs.some(ref => ref.current && ref.current.contains(event.target))) {
                return
            }
            handler(event)
        }

        document.addEventListener("mousedown", listener)
        document.addEventListener("touchstart", listener)

        return () => {
            document.removeEventListener("mousedown", listener)
            document.removeEventListener("touchstart", listener)
        }
    }, [refs, handler])
}

export default useClickOutsideHandler
